import * as React from "react";

class Checkbox extends React.Component<
    React.InputHTMLAttributes<HTMLInputElement> & {
        title: string;
        type: string;
    }
> {
    public render(): React.ReactElement {
        const { title, type, ...other } = this.props;
        return (
            <div className="checkbox-holder">
                <div className="flex_spacer" />
                <div>{title}</div>
                <input type={type} {...other} />
            </div>
        );
    }
}

export { Checkbox };
